import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function EditMealType() {
    const [formData, setFormData] = useState({
        title: ""
    });

    const [disableBtn, setDisableBtn] = useState(false);
    const location = useLocation();
    const data = location.state.data;
    const name = location.state.name;
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        setFormData({
            title: data.title,
        });
    }, []);

    const handleInputChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisableBtn(true);
        try {
            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
            };
            const formdata = new FormData();
            formdata.append("title", formData.title);
            formdata.append("typeId", id);

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/mealtype/edit-type`,
                formdata,
                { headers }
            );
            if (response.data.statusCode === 200) {
                navigate(-1);
                toast.success(response?.data?.message);
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to edit Meal Type. Please try again.", error);
        }
        setDisableBtn(false);
    };

    return (
        <>
            <Layout>
                <ToastContainer />
                <div>
                    <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
                        <div className="flex justify-between items-center">
                            <h2 className="text-xl font-medium">Edit Meal Type</h2>

                            <button
                                onClick={() => navigate(-1)}
                                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                            >
                                Back
                            </button>

                        </div>
                        <div className="mt-10" onSubmit={handleSubmit}>
                            <form action="">
                                <div className="">
                                    <label htmlFor="" className="text-sm">
                                        Name
                                    </label>{" "}
                                    <br />
                                    <input
                                        type="text"
                                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                                        placeholder="Name"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="mt-8 text-end">
                                    <button
                                        type="submit"
                                        className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                                        disabled={disableBtn}
                                    >
                                        <i className="fa fa-plus"></i>{" "}
                                        {disableBtn ? "Updating ..." : "Edit Meal Type"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}
